/**
 * Brazilian Portuguese translations
 */

export default {
  'Not included': 'Não incluído',
  Included: 'Incluído',
  Refresh: 'Atualizar',
  Unlimited: 'Ilimitado',
  'Pricing plans': 'Planos de preços',
  'Select an option': 'Selecione uma opção',
  'Play video': 'Reproduzir vídeo',
  'Pause video': 'Pausar vídeo',
  // Add more translations here
}
